<!-- Overlay de Loading -->
<div class="loading-overlay" *ngIf="abrindo">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Abrindo processo...</p>
</div>

<div class="container">
  <!-- Dados do Militar -->
  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiario.orgao?.sigla }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="11"></app-etapas-beneficio>

  <h1 class="page-title">Abrir Processo</h1>

  <mat-card class="section-card" *ngIf="tentativa && tentativa.estado !== 'SEM_TENTATIVA'">
    <h3>Tentativa de abertura</h3>
    <p>Estado: {{tentativa.estado}} · Tentativa {{tentativa.tentativa}}</p>
    <p *ngIf="tentativa.numeroProcesso">NUP registrado: {{tentativa.numeroProcesso}}</p>
    <pre style="white-space:pre-wrap">{{tentativa.auditoria}}</pre>
    <button mat-button (click)="carregarTentativa()">Atualizar situação</button>
    <button mat-raised-button color="primary" *ngIf="tentativa.numeroProcesso && tentativa.pedidoOriginal && !tentativa.beneficioId" (click)="retomarRegistro()" [disabled]="abrindo">Concluir registro local do NUP existente</button>
    <div *ngIf="!tentativa.beneficioId">
      <p>Confira a tentativa na Suíte antes de registrar o resultado. NUP existente será reutilizado; ausência comprovada permite uma única nova tentativa.</p>
      <mat-checkbox [(ngModel)]="ausenciaConfirmada" (change)="nupConferido=''">Conferi que nenhum processo foi criado</mat-checkbox>
      <mat-form-field *ngIf="!ausenciaConfirmada"><mat-label>NUP conferido</mat-label><input matInput [(ngModel)]="nupConferido" maxlength="100"></mat-form-field>
      <mat-form-field><mat-label>Evidência e justificativa da conferência</mat-label><textarea matInput [(ngModel)]="evidencia"></textarea></mat-form-field>
      <button mat-button (click)="conciliar()" [disabled]="conciliando || evidencia.trim().length < 10 || (!ausenciaConfirmada && !nupConferido.trim())">Registrar conferência</button>
    </div>
  </mat-card>

  <!-- Atestar Informações -->
  <mat-card class="section-card">
    <h3 class="section-title">Atestar Informações</h3>
    <mat-checkbox [(ngModel)]="atestado">
      Declaro, sob as penas da lei, que os documentos foram analisados e
      anexados pela área técnica deste setor, com base em dados pessoais e
      funcionais atualizados, estando apto à abertura do processo de
      concessão de benefício no âmbito do sistema legal SUPSEC.
    </mat-checkbox>
  </mat-card>

  <!-- Checklist Instituidor -->
  <mat-card class="section-card">
    <h3 class="section-title">
      Checklist dos Dados Informados <span class="subtitle">Instituidor</span>
    </h3>
    <div class="checklist-grid">
      <mat-checkbox [(ngModel)]="checklist.cpf">
        <strong>CPF:</strong> {{ beneficiario.cpf || '-' }}
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="checklist.rg">
        <strong>RG:</strong> {{ dadosPessoais?.identidade?.numero || '-' }}
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="checklist.nome">
        <strong>Nome:</strong> {{ beneficiario.nome || '-' }}
      </mat-checkbox>
      <mat-checkbox [(ngModel)]="checklist.nascimento">
        <strong>Nascimento:</strong>
        {{ (dadosPessoais?.dataNascimento | date : 'dd/MM/yyyy') || '-' }}
      </mat-checkbox>
    </div>
  </mat-card>

  <!-- Assunto -->
  <mat-card class="section-card">
    <h3 class="section-title">Assunto</h3>
    <div class="assunto-row">
      <mat-form-field appearance="outline" class="assunto-field">
        <mat-label>Selecione o assunto</mat-label>
        <mat-select [(ngModel)]="assuntoSelecionado">
          <mat-option *ngFor="let a of assuntos" [value]="a.value">{{ a.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button
        mat-flat-button
        color="primary"
        (click)="abrirProcesso()"
        [disabled]="abrindo || !podeAbrir()"
      >
        <mat-icon>folder_open</mat-icon>
        Abrir Processo
      </button>
    </div>
  </mat-card>
</div>
